import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgExpand = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.385 3.75a.64.64 0 0 0-.45.186m0 0a.64.64 0 0 0-.185.449v15.23a.635.635 0 0 0 .635.635h15.23a.635.635 0 0 0 .635-.635v-6.23a.75.75 0 0 1 1.5 0v6.23a2.135 2.135 0 0 1-2.135 2.135H4.385a2.135 2.135 0 0 1-2.135-2.135V4.385A2.135 2.135 0 0 1 4.385 2.25h6.23a.75.75 0 0 1 0 1.5h-6.23M15.404 3a.75.75 0 0 1 .75-.75H21a.75.75 0 0 1 .75.75v4.846a.75.75 0 0 1-1.5 0V4.811l-7.72 7.72a.75.75 0 1 1-1.06-1.061l7.72-7.72h-3.036a.75.75 0 0 1-.75-.75"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgExpand;
